// The `code` on Multi Pick's refusal when a ticked roll is allocated to another order line
// (Cloverbrook, Oct 2026). Mirrors TMSWeb.Common.Constants.AllocatedElsewhereRefusalCodes.
export const AllocatedElsewhereRefusalCode = 'AllocatedElsewhere';
